// extracted by mini-css-extract-plugin
export default {"titleBlock":"projects-manual_titleBlock__IT2aS","title":"projects-manual_title__-mUvR","description":"projects-manual_description__Szv19"};